
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Shield, Award, Clock, ArrowRight, Phone, Calculator, MapPin, TrendingUp, Euro, CheckCircle2 } from 'lucide-react';

const AchatMetauxHero = () => {
  return (
    <div className="relative bg-gradient-to-br from-slate-800 via-gray-700 to-amber-600 text-white py-20 mt-20 overflow-hidden">
      <div className="absolute inset-0 bg-black/20"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full -translate-y-48 translate-x-48"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-32 -translate-x-32"></div>
      <div className="absolute top-1/2 left-1/4 w-32 h-32 bg-amber-400/10 rounded-full"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Content */}
            <div>
              <Badge className="mb-6 bg-white/20 text-white border-white/30 hover:bg-white/30">
                <Award className="w-4 h-4 mr-2" />
                Expert en Rachat de Métaux depuis 25+ ans
              </Badge>
              
              <h1 className="text-5xl md:text-6xl font-heading font-bold mb-6 leading-tight">
                Achat de Métaux
                <span className="text-amber-300"> et Ferrailles</span>
              </h1>
              
              <p className="text-xl md:text-2xl mb-8 text-gray-100 leading-relaxed">
                Valorisez vos métaux aux <strong className="text-amber-300">meilleurs prix du marché</strong>. 
                Expertise reconnue, paiement immédiat, service professionnel.
              </p>
              
              {/* Key Benefits */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                <div className="flex items-center">
                  <CheckCircle2 className="h-6 w-6 mr-3 text-amber-300 flex-shrink-0" />
                  <span className="font-medium">Prix garantis attractifs</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle2 className="h-6 w-6 mr-3 text-amber-300 flex-shrink-0" />
                  <span className="font-medium">Paiement immédiat</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle2 className="h-6 w-6 mr-3 text-amber-300 flex-shrink-0" />
                  <span className="font-medium">Tous types de métaux</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle2 className="h-6 w-6 mr-3 text-amber-300 flex-shrink-0" />
                  <span className="font-medium">Service rapide 48h</span>
                </div>
              </div>
              
              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <Link to="/contact">
                  <Button size="lg" className="bg-amber-500 hover:bg-amber-600 text-gray-900 font-semibold px-8 shadow-lg">
                    <Phone className="w-5 h-5 mr-2" />
                    Obtenir un devis gratuit
                  </Button>
                </Link>
                <Link to="/estimation-metaux">
                  <Button size="lg" variant="outline" className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 shadow-lg bg-white/10 backdrop-blur-sm font-semibold">
                    <Calculator className="w-5 h-5 mr-2" />
                    Estimation en ligne
                  </Button>
                </Link>
              </div>
            </div>
            
            {/* Right Content - Stats */}
            <div className="lg:text-center">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
                <h3 className="text-2xl font-heading font-bold mb-6 text-amber-300">
                  Pourquoi nous choisir ?
                </h3>
                
                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-amber-300 mb-2">25+</div>
                    <p className="text-gray-200 text-sm">Années d'expertise</p>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-amber-300 mb-2">8</div>
                    <p className="text-gray-200 text-sm">Départements couverts</p>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-amber-300 mb-2">100%</div>
                    <p className="text-gray-200 text-sm">Paiement garanti</p>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-amber-300 mb-2">48h</div>
                    <p className="text-gray-200 text-sm">Service rapide</p>
                  </div>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-center">
                    <Shield className="h-6 w-6 mr-3 text-amber-300" />
                    <span className="font-medium">Expertise reconnue depuis 1998</span>
                  </div>
                  <div className="flex items-center">
                    <Euro className="h-6 w-6 mr-3 text-amber-300" />
                    <span className="font-medium">Meilleurs prix du marché</span>
                  </div>
                  <div className="flex items-center">
                    <MapPin className="h-6 w-6 mr-3 text-amber-300" />
                    <span className="font-medium">Service de proximité</span>
                  </div>
                  <div className="flex items-center">
                    <TrendingUp className="h-6 w-6 mr-3 text-amber-300" />
                    <span className="font-medium">Cours mis à jour quotidiennement</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchatMetauxHero;
